import { takeLatest, put, all, call } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_AAC_API } from 'services/rotasp/path';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';

// ACTIONS
import {
	enviaCentralLiberacaoSuccess,
	enviaCentralLiberacaoFailure,
} from './actions';

// TYPES
import { Types, EnviaCentralLiberacaoRequest } from './types';

function* enviaCentralLiberacaoRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: EnviaCentralLiberacaoRequest } = request;

	const { usuario } = payload;

	delete payload.usuario;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_AAC_API,
		`central-liberacao/atendimentos`,
		payload,
		{ usuario },
	);

	if (response.status === 200) {
		yield put(enviaCentralLiberacaoSuccess(response.data));
	} else if (response.error) {
		yield put(enviaCentralLiberacaoFailure());
	}
}

export default all([
	takeLatest(Types.ENVIA_CENTRAL_LIBERACAO, enviaCentralLiberacaoRequest),
]);
